import { render, staticRenderFns } from "./important-information-create-sending-data.view.vue?vue&type=template&id=6056f6d4&"
import script from "./important-information-create-sending-data.view.vue?vue&type=script&lang=ts&"
export * from "./important-information-create-sending-data.view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports